import React,{Component} from 'react';
import {NavLink} from 'react-router-dom';
import {InView} from 'react-intersection-observer';
import { connect } from 'react-redux';
import {getFullMediaUrl} from 'app/static_func';
import ReactHtmlParser from 'react-html-parser';
import CircularProgressBar from 'components/circularProgressBar/circularProgressBar';

import * as routes from '../../../../constants/routes';

import './expansions.scss'
import matchShaking from 'assets/icons/match_shaking.svg';
import matchingTablet from 'assets/icons/matching_tablet.svg';
import cityView from 'assets/icons/city_view_grey.svg';
import tabletView from 'assets/icons/tablet_view_grey.svg';
import carVid from 'assets/mock/car_open_vid.mp4';

class Expansions extends Component{
    constructor(props){
        super(props);

        this.state = {
            inView:{
                flatProgress:false,
                circleProgress:false
            },
            showImage: false,
            screenWidth:0
        }

        this.fillProgress = this.fillProgress.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.showImage = this.showImage.bind(this);

        this.videoRef = React.createRef();
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ screenWidth: window.innerWidth});
    }

    fillProgress(inView, entry, elm){
        let updatedState;
        if(inView)
            updatedState = {...this.state.inView,[elm] : true};
        else
            updatedState = {...this.state.inView,[elm] : false};
        this.setState({inView:updatedState});
    }

    playVideo(inView){
        if (inView){
            this.videoRef.current.node.play();
        }
    }

    showImage(inview){
        if (inview){
            this.setState({showImage:true});
        }
    }

    render(){

        const is_tablet = this.props.deviceState === "tablet";
        const isLaptopOrDesktop = this.props.deviceState === "desktop" || this.props.deviceState === "desktop_large";
        const isLaptop = this.props.deviceState === 'desktop';

        const peepsScore = this.props.peepsScore;
        const date = this.props.date;
        const easySearch = this.props.easySearch;


        let radius = this.state.screenWidth*0.18;

        if (is_tablet)
            radius = radius - 70;
        else if(isLaptopOrDesktop){
            if(isLaptop)
                radius = this.state.screenWidth*0.05;
            else radius = this.state.screenWidth*0.04;
        }
        return(
            <section className='expansion'>
                <div className='topWrapper'>
                    {!isLaptopOrDesktop &&
                    <div className='titleContainer'>
                        <h1 className='title'> {peepsScore.title} <strong>{peepsScore['title-bold']}</strong></h1>
                    </div>
                    }
                    <div className='carImage'>
                        <InView as='video'  treshold={1} ref={this.videoRef} playsInline
                               muted='muted'  onChange={(inView) => this.playVideo(inView)}>
                            <source src={carVid} type='video/mp4'/>
                            Your browser does not support the video tag.
                        </InView>
                    </div>

                    <div className='topPara'>
                        {isLaptopOrDesktop &&
                        <div className='titleContainer'>
                            <h1 className='title'>{peepsScore.title} <strong>{peepsScore['title-bold']}</strong></h1>
                            <div className='divider'/>
                        </div>
                        }

                        <div className='grades'>
                        <div className='progressGrade'>
                            <h3 className='label'> {peepsScore['sub-title']} </h3>
                            <div className='progressBar'>
                                <InView as="div"
                                        className={"progress fillProgress " + (this.state.inView.flatProgress ? 'in' : '')}
                                        onChange={(inView, entry) => this.fillProgress(inView, entry, 'flatProgress')}
                                        treshold={1}/>
                            </div>
                        </div>

                        <CircularProgressBar radius={radius} stroke={4} progress={82}/>
                    </div>
                <div className='detailsContainer'>
                    <div className="detailsText">{ReactHtmlParser(peepsScore.description)}</div>

                    <NavLink to = {routes.howItWorks} className='link'>
                        <div className='button'>{peepsScore['btn-text']}</div>
                    </NavLink>
                </div>
                    </div>
                </div>

                {!isLaptopOrDesktop &&
                <div className='matchingContainer'>
                    <h2 className="matchingTitle">{date.title}</h2>
                    <img src={matchShaking} className="floatShaking" alt='\'/>
                    <InView as='div' className="matchImage"
                            onChange={(inView) => this.showImage(inView)}
                            treshold={0.1}>
                        {this.state.showImage && <img src={getFullMediaUrl(date.image.path)} alt={date.image.alt}/>}
                    </InView>
                    <div className="detailsText">{ReactHtmlParser(date.content)}</div>
                    <NavLink to = {routes.placeholder} className = "linkBtn">
                        <div className='button'>{date['btn_title']}</div>
                    </NavLink>
                </div>
                }

                {isLaptopOrDesktop &&
                <div className='matchingContainer'>
                    <div className='data'>
                    <h2 className="matchingTitle">{date.title}</h2>
                        <div className='divider'/>
                    <div className="detailsText">{ReactHtmlParser(date.content)}</div>
                    <NavLink to = {routes.placeholder} className = "linkBtn">
                        <div className='button'>{date['btn_title']}</div>
                    </NavLink>
                        <img src={cityView} alt='cityView' className='icon'/>
                    </div>

                    <img src={matchShaking} className="floatShaking" alt='\'/>
                    <InView as='div' className="matchImage"
                            onChange={(inView) => this.showImage(inView)}
                            treshold={0.1}>
                        {this.state.showImage && <img src={getFullMediaUrl(date.image.path)} alt={date.image.alt}/>}
                    </InView>
                </div>
                }
                {!isLaptopOrDesktop &&
                <div className="matchingContainer">
                    <h2 className="matchingTitle">{easySearch.title}</h2>
                    <img className="floatShaking" src={matchingTablet} alt='tabletHolder'/>
                    <div className="matchImage">
                        {this.state.showImage && <img src={getFullMediaUrl(easySearch.image.path)} alt={easySearch.image.alt}/>}
                    </div>
                    <div className="detailsText">{ReactHtmlParser(easySearch.content)}</div>

                    <NavLink className="linkBtn" to={routes.results}>
                        <div className="button">{easySearch['btn-text']}</div>
                    </NavLink>
                </div>
                }

                {isLaptopOrDesktop &&
                <div className="matchingContainer bottom">
                    <img className="floatShaking right" src={matchingTablet} alt='tabletHolder'/>
                    <div className="matchImage">
                        {this.state.showImage && <img src={getFullMediaUrl(easySearch.image.path)} alt="matchHolder"/>}
                    </div>
                    <div className='data'>
                    <h2 className="matchingTitle">{easySearch.title}</h2>
                        <div className='divider'/>
                    <div className="detailsText">{ReactHtmlParser(easySearch.content)}</div>

                    <NavLink className="linkBtn" to={routes.results}>
                        <div className="button">{easySearch['btn-text']}</div>
                    </NavLink>
                        <img src={tabletView} alt='tabletView' className='icon'/>
                    </div>
                </div>
                }

            </section>
        )
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        peepsScore: store.config.PeepsScore,
        date: store.config.Date,
        easySearch: store.config.EasySearch,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {

    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Expansions);
